import { Config } from '@app/configuration/config';
import { AuthConfig } from 'angular-oauth2-oidc';

export function authConfig(config: Config): AuthConfig {
  return {
    clientId: config.oAuthClientId,
    issuer: config.oAuthIssuerUri,
    logoutUrl: config.logoutUrl,
    redirectUri: config.oAuthRedirectUri,
    responseType: 'code',
    scope: 'openid email aws.cognito.signin.user.admin profile',
    /*
      * When enabled validates that all OAuth2 urls start with the same url.
      * Cognito has different urls and thus we need to disable this.
      */
    strictDiscoveryDocumentValidation: false,
  };
}
